import { IOrder, OrderStatus } from "../../types/orders";

/**
 * DEPRECATED: Order agora tem status próprio.
 * Use order.status diretamente ao invés de calcular a partir dos items.
 *
 * Mantido para compatibilidade temporária.
 */
export const getOrderStatus = (order: IOrder): OrderStatus | "MIXED" => {
  // Usa o status do Order diretamente
  if (order.status) {
    return order.status;
  }

  // Fallback: se todos items cancelados, considera CANCELED
  const allItemsCanceled = order.items.every((item) => item.is_canceled);
  if (allItemsCanceled) {
    return "CANCELED";
  }

  const hasAnyCanceled = order.items.some((item) => item.is_canceled);
  if (hasAnyCanceled) {
    return "MIXED";
  }

  return "PENDING"; // Fallback
};

export const getTotal = (order: IOrder) => {
  // Soma apenas items ativos (não cancelados)
  const itemsTotal = order.items.reduce((acc, item) => {
    if (item.is_canceled) {
      return acc;
    }

    return (acc += item.amount * item.price);
  }, 0);

  const deliveryFee = parseFloat(order.delivery_fee);
  const discount = parseFloat(order.discount);

  // Se order foi cancelado, não adiciona taxa de entrega nem desconto
  if (order.status === "CANCELED") {
    return itemsTotal;
  }

  return itemsTotal + deliveryFee - discount;
};

export const getTotalCost = (order: IOrder) => {
  // Soma apenas items ativos (não cancelados)
  const itemsTotal = order.items.reduce((acc, item) => {
    if (item.is_canceled) {
      return acc;
    }

    return (acc += item.amount * item.cost);
  }, 0);

  return itemsTotal;
};
